module.exports = __webpack_public_path__ + "static/media/rhytm.0ffd89ff.png";